<h5 class="mb-3">
  <strong>Basic</strong>
</h5>
<div class="mb-5">
  <nz-skeleton [nzActive]="true"></nz-skeleton>
</div>